// extracted by mini-css-extract-plugin
export var forWhom = "style-module--for-whom--7a6d0";
export var forWhom__content = "style-module--for-whom__content--15b8a";
export var forWhom__item = "style-module--for-whom__item--bb2d7";
export var forWhom__list = "style-module--for-whom__list--a0c54";
export var forWhom__textBlock = "style-module--for-whom__text-block--d52ea";
export var forWhom__title = "style-module--for-whom__title--53d94";
export var forWhom__undertext = "style-module--for-whom__undertext--bcfff";
export var forWhom__undertextItem = "style-module--for-whom__undertext-item--d457c";
export var forWhom__wrapper = "style-module--for-whom__wrapper--37de6";